const postMessageToParent = (event) => {
    parent.window.postMessage(event, "*");
}

export {postMessageToParent}